module.exports = __webpack_public_path__ + "img/btn_pg_paypal.8583e1bc.png";